const baseJson = () => {
    return {
        id: null,
        userName: null,
        firstName: null,
        lastName: null,
        chucVu: null,
        notes: null
    }
}

export const accountDOfficeModel = {
    baseJson
}
